import { AssetsBiographyFormViewModel } from './assets-biography-form.viewmodel';
import { withViewModel } from '../../../../../infrastructure/components/with-view-model';
import { AssetsBiographyFormPresentation } from './assets-biography-form.presentation';

interface ContainerProps {
    accountId: number;
    eventId: number;
    organizationId?: number | null;
    attendeeId?: number | null;
    biography: string;
    closeAssetsBiographyPopup: () => void;
    setSpeakerBiography: (biography: string, organizationId: number, attendeeId: number) => void;
}

const AssetsBiographyFormContainer = withViewModel(AssetsBiographyFormPresentation, (props: ContainerProps) => {
    const vm = new AssetsBiographyFormViewModel(
        props.accountId,
        props.eventId,
        props.organizationId,
        props.attendeeId,
        props.biography,
        props.closeAssetsBiographyPopup,
        props.setSpeakerBiography
    );
    return vm;
});

export { AssetsBiographyFormContainer as AssetsBiographyForm };